const mixChannel = (channel: number, alpha: number): string =>
  Math.round(channel * alpha + 255 * (1 - alpha))
    .toString(16)
    .padStart(2, '0');

/** `#rrggbb` blended with white; `alpha` is the share of the original color. */
export function mixWithWhite(hex: string, alpha: number): string {
  if (!hex) {
    return '';
  }

  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `#${mixChannel(r, alpha)}${mixChannel(g, alpha)}${mixChannel(b, alpha)}`;
}
